import { DatePickerProps } from "@mui/x-date-pickers-pro";
import { DatePicker7 } from "../../platform-style";
import React from "react";

export interface DatePickerLegacyProps extends DatePickerProps<Date> {
  value: any;
  inputFormat: string;
  renderInput: () => React.ReactElement;
}

/**
 * @deprecated Use DatePicker7 instead.
 */
export const DatePicker = (props: DatePickerLegacyProps) => {
  let value = props.value;

  if (props.value != null && !(props.value instanceof Date)) {
    value = new Date(props.value);
  }

  let inputProps;

  if (props.renderInput) {
    inputProps = props.renderInput().props;
  }

  return (
    <DatePicker7
      {...props}
      value={value}
      format={props.inputFormat ? props.inputFormat : props.format}
      slotProps={inputProps ? { textField: { ...inputProps } } : undefined}
    />
  );
};
